import Vue from 'vue'

window.storage = {
    
    box: [],
    
    isStored(path){
        
        if(typeof this.box[path] !== 'undefined'){
            
            return true;
        }
        
        return false;
    },
    
    set(path, data){
        
        this.box[path] = data;
    },
    
    get(path){
        
        return this.box[path];
    }
};

Vue.prototype.$storage = window.storage;


// WEBPACK FOOTER //
// ./src/assets/js/libs/storage.js